import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const baseSelectButtonClasses = generateUtilityClasses(
  'AFBaseSelectButton',
  [
    'selectButton',
    'iconsWrapper',
    'clearIcon',
    'expandIcon',
    'small',
    'medium',
    'large',
    'fullWidth',
    'formLabel',
    'label',
    'errorContainer',
    'textError',
    'helperText',
    'footer',
    'helpIcon'
  ]
);
